// extracted by mini-css-extract-plugin
export default {"wrapper":"Paypal_wrapper__cDUzV","button":"Paypal_button__7XVvH","text":"Paypal_text__r1oIs"};